/// <amd-module name="Repos/Views/Import/PanelImport" />
export { PanelImport } from "Components/PanelImport/PanelImport";
export { PanelImportProps } from "Components/PanelImport/PanelImport.Props";
